import { Injectable } from '@angular/core';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { Selector } from '@ngxs/store';
import { RemitosDetailPreviewState } from './remitos-detail_preview.state';
import { RemitosDetailPreviewStateModel } from './remitos-detail_preview.state-model';

@Injectable()
export class RemitosDetailPreviewSelectors {
  @Selector([RemitosDetailPreviewState])
  static item(
    state: RemitosDetailPreviewStateModel
  ): models.detailPreview.ItemView | null {
    return state.activeItem;
  }
}
